export default __webpack_public_path__ + "static/lootbox1-min-8e364d04689e5207e4d85b6681c417bf.png";